import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import axios from 'axios'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import moment from 'moment'
import auth from './auth/jwt.js'
import httpResource from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import routerResource from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js'

// import ZfTheme from 'zf_vuejs_pkg/src/components'

import { library, config, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'
import { createRouter } from './router'
import store from './store'

import 'es6-promise/auto'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/style.scss'
import apiFunctions from './helpers/apiFunctions'
import VueVirtualScroller from 'vue-virtual-scroller'
import { ClientTable } from 'vue-tables-2'
// Add fontawesome icons globally
import {
  faHome,
  faTable,
  faTrophy,
  faChild,
  faArrowsAlt,
  faShareAlt,
  faAddressCard,
  faSearch,
  faSave,
  faDownload,
  faPlus,
  faEdit,
  faTrashAlt,
  faEye,
  faUser,
  faKey,
  faTachometerAlt,
  faCubes,
  faSyncAlt,
  faDesktop,
  faServer,
  faFileAlt,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFilePdf,
  faHashtag,
  faBuilding,
  faBook,
  faBookmark,
  faBriefcase,
  faTag,
  faIdBadge,
  faGlobeEurope,
  faTimes,
  faUsers,
  faFlask,
  faClipboardList,
  faPencilRuler,
  faPenSquare,
  faPencilAlt,
  faTools,
  faLayerGroup,
  faClipboardCheck,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faCaretDown,
  faCaretUp,
  faChevronLeft,
  faAngleDown,
  faAngleUp,
  faBars,
  faVial,
  faCheckCircle,
  faExclamationCircle,
  faChartBar,
  faExclamation,
  faTimesCircle,
  faInfo,
  faCheck,
  faMinus,
  faExternalLinkAlt,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faInfoCircle,
  faCloudUploadAlt,
  faExpand,
  faCompress,
  faCloud,
  faSortDown,
  faSortUp,
  faSort,
  faPauseCircle,
  faCircleNotch
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHome,
  faTable,
  faTrophy,
  faChild,
  faArrowsAlt,
  faExpand,
  faCompress,
  faShareAlt,
  faAddressCard,
  faCloudUploadAlt,
  faFileAlt,
  faFileWord,
  faFileExcel,
  faInfoCircle,
  faCloud,
  faExternalLinkAlt,
  faExternalLinkSquareAlt,
  faFilePowerpoint,
  faFilePdf,
  faSearch,
  faPlus,
  faTimes,
  faDownload,
  faSave,
  faEdit,
  faTrashAlt,
  faEye,
  faUser,
  faKey,
  faTachometerAlt,
  faCubes,
  faSyncAlt,
  faDesktop,
  faServer,
  faHashtag,
  faBuilding,
  faBook,
  faBookmark,
  faBriefcase,
  faTag,
  faIdBadge,
  faGlobeEurope,
  faUsers,
  faFlask,
  faClipboardList,
  faClipboardCheck,
  faPencilRuler,
  faPenSquare,
  faPencilAlt,
  faTools,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faCaretDown,
  faCaretUp,
  faAngleDown,
  faAngleUp,
  faVial,
  faBars,
  faExclamation,
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faTimesCircle,
  faLayerGroup,
  faChartBar,
  faCheck,
  faMinus,
  faSortDown,
  faSortUp,
  faSort,
  faInfo,
  faPauseCircle,
  faCircleNotch
)

config.autoReplaceSvg = 'nest'

dom.watch()

const initializeVue = async () => {
  const router = await createRouter()
  router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title
    next()
  })
  Vue.router = router
  Vue.use(router)

  Vue.config.productionTip = false
  Vue.prototype.$env = process.env
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

  moment.locale('en-GB')
  Vue.prototype.moment = moment

  Vue.use(VueAxios, axios)
  Vue.use(ElementUI, { locale })
  Vue.use(BootstrapVue)
  Vue.use(VueVirtualScroller)
  Vue.use(ClientTable) // eslint-disable-line
  Vue.component('font-awesome-icon', FontAwesomeIcon)

  Vue.use(VueAuth, {
    auth: auth,
    http: httpResource,
    router: routerResource,
    parseUserData: function (res) {
      return apiFunctions.createPermissions(res)
    },
    tokenStore: ['cookie', 'storage'],
    refreshData: {
      url: 'auth/refresh',
      method: 'GET',
      enabled: true,
      interval: 1
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

initializeVue()
